import { get } from 'lodash';
import { getTheme } from './themes';
/**
 * Checks if a theme path exists in our theme object
 *
 * Example
 * ```
 * isThemePath('colors.gray.100') // => true
 * isThemePath('wat') // => false
 * ```
 */
export function isValidThemePath(path) {
    const theme = getTheme('light');
    const token = get(theme, path);
    return token !== undefined;
}
